import React, { Component } from 'react';
import { connect } from 'react-redux';
import { path } from 'ramda';

import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Paper from '@material-ui/core/Paper';
import Button from '../../constant/Button';
import AddIcon from '@material-ui/icons/Add';
import { blue } from '@material-ui/core/colors';

import { InitWaitingTime, SetStateWithTime } from '../../common/SetTime.js';
import { Colors,Icons } from '../../themes';

import Language from '../../constant/Language';

import EmptyRows from '../../componets/EmptyRow.jsx';
import DialogPanel from '../../componets/DialogPanel.jsx';

import * as AppointmentActions from '../../actions/Actions_Appointment.js';
import * as LocationActions from '../../actions/Actions_LocationServicesManager';

import { Province } from '../../constant/JSON/Province';

import CONFIG from '../../config';
const { BorderColorIcon } = Icons;


const fildeList = [
    { label: '', name: '', isOrder: false, },
    { label: 'NAME', name: 'name', isOrder: true, },
    { label: 'DESCRIPTION', name: 'description', isOrder: true, },
    { label: 'ADDRESS', name: 'address', isOrder: false, },
    { label: 'PARENT ID', name: 'parentId', isOrder: false, },
    { label: 'STATUS', name: 'status', isOrder: false, },
    { label: '', name: '', isOrder: false, }];

const _callStyle = { textAlign: 'center', paddingLeft: '5px', paddingRight: '10px', minWidth: 70 };
const _callName = { textAlign: 'left', paddingLeft: '5px', paddingRight: '5px', minWidth: 200 };
const _headCall = { paddingLeft: '5px', paddingRight: '5px', };
const _wording = { header: 'Appoiontment Manage' }

let LocationServicesList = [];
let AppoiontmentList = [];
let waitingTime = true;

class AppoiontmentListPanel extends Component {

    state = { isLoading: false, msgError: undefined, dialogType: undefined, orderBy: 'desc', sortFilde: undefined, }

    constructor(props) {
        super(props);
        this.props.getAPILocationServicesList();
    }

    componentWillReceiveProps(nextProps) {

        const { AppointmentManager, LocationServicesManager } = nextProps;

        if (!!AppointmentManager) {
            const { actions, data } = AppointmentManager.APPOINTMENT_REDUCER;

            switch (actions) {
                case AppointmentActions.GET_APPOINTMENT_SUCCESS:
                    { SetStateWithTime(this, waitingTime); } break;
                case AppointmentActions.GET_APPOINTMENT_FAILURE:
                    { SetStateWithTime(this, waitingTime) } break;
            }
        }

        if (!!LocationServicesManager) {
            const { actions, data } = LocationServicesManager.LOCATIONSERVICES_REDUCER;
            switch (actions) {
                case LocationActions.GET_LOCATIONSERVICES_SUCCESS:
                    LocationServicesList = data.result.datas;
                    { SetStateWithTime(this, waitingTime); } break;
                case LocationActions.GET_LOCATIONSERVICES_FAILURE:
                    { SetStateWithTime(this, waitingTime); } break;
            }
        }

    }

    render() {

        const { classes, CreatePanel, EditInfo, onClickHandle } = this.props;
        const { datas, } = this.props.AppoiontmentList;

        AppoiontmentList = datas || [];
        const _isAppoiontment = (AppoiontmentList.length > 0);

        const { isLoading, msgError, dialogType } = this.state;

        return (
            <React.Fragment>
                {(isLoading) && <DialogPanel Active={isLoading} MSG={msgError} Type={dialogType} OnClose={() => { this.onCloseDialog() }} />}
                <Paper className={classes.root}>
                    <Table className={classes.table}>
                        <TableHead>
                            <TableRow style={{ height: '100%' }}>
                                <TableCell colSpan={fildeList.length - 1} style={{ padding: '0px' }} >
                                    <Button.Themes TitleText={_wording.header} style={{ width: '100%' }} buttonStyle={{ marginTop: 0, padding: 15 }}
                                    // onClick={() => this.setState({ searchActive: !searchActive })} 
                                    />
                                </TableCell>
                                <TableCell colSpan={1} style={{ padding: '0px' }} >
                                    <div style={{ textAlign: 'center' }} onClick={() => CreatePanel()}>
                                        <Button.Icons theme icon={<AddIcon />} tooltip={'Create'} />
                                    </div>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableHead>
                            <TableRow>
                                {fildeList.map((_filde, index) => {
                                    return (
                                        <TableCell key={index} style={(index === 1) ? _headCall : _callStyle}>
                                            {GetSortIcon(this.state.orderBy, _filde, this.handleRequestSort)}
                                        </TableCell>)
                                })}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {(_isAppoiontment) ? AppoiontmentList.map(info => {
                                const { id, picture, actived, parentId, province, gallery } = info;
                                // console.log('props', this.props);
                                // console.log('LocationServicesList', LocationServicesList);
                                // console.log('info', info);
                                const _backgroundImage = { width: '70px', height: '50px', backgroundColor: 'gray', backgroundImage: `url(${CONFIG.host}${path([0, 'thumbnail'], gallery)})`, backgroundRepeat: 'round' };
                                const LanguageAppoiontment = path(['language',], this.props.AppoiontmentList);
                                // console.log('LanguageAppoiontment', LanguageAppoiontment);
                                let TH = LanguageAppoiontment === 'TH'
                                let EN = LanguageAppoiontment === 'EN'
                                const NAME = info[LanguageAppoiontment].name;
                                const DESCRIPTION = info[LanguageAppoiontment].description;

                                const _infoProvince = Province.find(val => val.code === province)
                                const ADDRESS = TH ? _infoProvince.name : EN ? _infoProvince.name_EN : '-'

                                const _infoLocation = LocationServicesList.find(val => val.code === parentId)
                                const LOCATION = _infoLocation && _infoLocation[LanguageAppoiontment].name;
                                // console.log('LOCATION', _infoLocation[LanguageAppoiontment].name)
                                return (
                                    <TableRow hover style={{ cursor: 'pointer' }} key={id} >
                                        <TableCell style={{ ..._callStyle, ...{ minWidth: 80, paddingRight: 5 } }} onClick={() => { { onClickHandle(info) } }} ><div style={_backgroundImage} /></TableCell>
                                        <TableCell style={_callName} onClick={() => { { onClickHandle(info) } }} >{NAME || '-'}</TableCell>
                                        <TableCell style={_callName} onClick={() => { { onClickHandle(info) } }} >{DESCRIPTION || '-'}</TableCell>
                                        <TableCell style={_callName} onClick={() => { { onClickHandle(info) } }} >{ADDRESS || '-'}</TableCell>
                                        <TableCell style={_callStyle} onClick={() => { { onClickHandle(info) } }} >{LOCATION || '-'}</TableCell>
                                        <TableCell style={{ ..._callStyle, ...{ color: (actived) ? Colors.success : Colors.error } }} onClick={() => { }} >{actived ? 'Active' : 'Inactive'}</TableCell>
                                        <TableCell style={_callStyle}>
                                            <Button.Icons icon={<BorderColorIcon />} tooltip={'Edit'} onClick={() => { EditInfo(info) }} />
                                        </TableCell>
                                    </TableRow>
                                );
                            }) : <EmptyRows fildeList={fildeList} />}
                        </TableBody>
                    </Table>
                    {(_isAppoiontment) && GetPagination(this.props.AppoiontmentList, this.onNextPage, this.onChangeLimit, this.onChangeLanguage)}
                </Paper>
            </React.Fragment>

        );
    }

    //===============================================================================================================================================================

    handleRequestSort = (sortFilde) => {

        const { orderBy, field } = sortFilde;
        const _fildeName = field.name;

        AppoiontmentList = (orderBy === 'desc')
            ? AppoiontmentList.sort((a, b) => (b[_fildeName] < a[_fildeName] ? -1 : 1))
            : AppoiontmentList.sort((a, b) => (a[_fildeName] < b[_fildeName] ? -1 : 1));

        this.setState({ orderBy: ((orderBy === 'asc') ? 'desc' : 'asc'), sortFilde: _fildeName });
    };

    onChangeLimit = (_limitRows, _language) => {
        this.setState({ isLoading: true });
        this.props.getAPIAppointmentList({ page: 0, num_limit: _limitRows, language: _language });
    }

    onNextPage = (_pageNumber, _limit, _language) => {
        this.setState({ isLoading: true });
        this.props.getAPIAppointmentList({ page: _pageNumber, num_limit: _limit, language: _language });
    }
    onChangeLanguage = (_language) => {
        this.setState({ isLoading: true });
        this.props.getAPIAppointmentList({ page: 0, num_limit: 10, language: _language });
    }
    onCloseDialog = () => (this.setState({ isLoading: false, msgError: undefined, dialogType: undefined }));

    //===============================================================================================================================================================
}


function GetSortIcon(orderBy, field, handleRequestSort) {
    return (
        <TableSortLabel active={field.isOrder} direction={orderBy} onClick={() => { (field.isOrder) && handleRequestSort({ orderBy, field }) }}>
            {field.label}
        </TableSortLabel>)
}

function GetPagination(_ListCount, onNextPage, onChangeLimit, onChangeLanguage) {

    const { total, page, limit, pageSize, language } = _ListCount;
    // console.log('_ListCount', _ListCount)
    return (
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Language LanguagePage={language} onChangeState={onChangeLanguage} isValue={true} />
            <TablePagination
                component="div"
                count={total || 0}
                rowsPerPage={limit || 25}
                page={page || 0}
                backIconButtonProps={{ 'aria-label': 'Previous Page', }}
                nextIconButtonProps={{ 'aria-label': 'Next Page', }}
                onChangePage={(event, page) => { onNextPage(page, limit, language) }}
                onChangeRowsPerPage={(event) => { onChangeLimit(event.target.value, language) }} />
        </div>
    )
}

const styles = theme => (
    {
        root: { width: '100%', marginTop: theme.spacing.unit * 3, overflowX: 'auto', marginBottom: 10, },
        table: { minWidth: 1024, }
    }
);

AppoiontmentListPanel.propTypes = { classes: PropTypes.object.isRequired, };

function mapStateToProps(state, ownProps) { return { ...state }; }

function mapDispatchToProps(dispatch) {
    return {
        getAPIAppointmentList: (_keyword) => {
            InitWaitingTime();
            dispatch(AppointmentActions.getAppointmentList(_keyword));
        },
        getAPILocationServicesList: (_keyword, _filter) => {
            InitWaitingTime();
            dispatch(LocationActions.getLocationServicesList(_keyword, _filter));
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(AppoiontmentListPanel));